<template>
  <div class="mycar">
    <div class="car-box text-c">
      <div v-for="item in list" :key="'list_' + item.id">
        <div class="car">
         <van-image
         width="190"
         height="100"
         fit="contain"
         :src="item.car.pic"
         />
         <van-row type="flex" justify="space-between">
          <van-col class="f-15 f-w carstype" span="8">{{item.brand.title}}{{item.car.title}}</van-col>
          <van-col class="platenum" span="8">
            <van-tag v-if="item.is_audit==0" round :data-code='item.id' :data-audit='item.is_audit' @click="showBottom">认证未成功</van-tag>
            <span v-else :data-code='item.id' :data-audit='item.is_audit' @click="showBottom">
              <van-tag class="province" type="primary">{{item.p_plate}}</van-tag>
              <van-tag plain type="primary">{{item.p_num}}</van-tag>
            </span>
          </van-col>
        </van-row>
        <van-popup
        v-model="approve"
        position="bottom"
        :style="{ height: '13%' }"
        >
        <van-cell-group>
          <van-cell :title="goTitle" @click="approveCar" />
          <van-cell title="删除车辆" @click="delCar" />
        </van-cell-group>
      </van-popup>
    </div>
  </div>
  <div class="nocar">
    <van-popup
    v-model="show"
    position="right"
    @close="close"
    :style="{ width: '80%', height: '100%' }"
    >
    <van-nav-bar
    :title="popTitle"
    left-arrow
    @click-left="onClickLeft"
    />
    <van-index-bar v-show="brands" highlight-color="#F6AB00">
      <div v-for="(item, index) in brandlist" :key="'list_' +index" >
        <van-index-anchor :index="index" />
        <div v-for="itemd in item" :key="'listd_' + itemd.id">
          <van-cell @click="changeCar" :icon="itemd.logo" :data-img="itemd.logo" :data-name="itemd.title" :data-code='itemd.id' :title="itemd.title" title-class="text-l f-w mt-5" />
        </div>
      </div>
    </van-index-bar>
    <div class="cars" v-show="cars">
      <van-cell class="bg" :icon="brand_img" :title="brand_name" title-class="text-l f-w" />
      <van-cell v-for="item in carslist" :key="'listc_' + item.id" @click="changeModel" :data-name="item.title" :data-code='item.id' :title="item.title" :icon="item.pic" title-class="text-l f-w mt-5" />
    </div>
    <div v-show="models">
      <van-cell class="bg" :title="model_name" title-class="text-l f-w" />
      <van-cell @click="changeOk" v-for="item in modelist" :key="'listm_' + item.id" :data-code='item.id' :data-name="item.title" :title="item.title" :label="item.year" title-class="text-l f-w" />
    </div>
  </van-popup>
  <van-button icon="add-o" @click="showRight">添加爱车</van-button>
</div>
</div>
</div>
</template>
<script>
  import list from '../../../api/member/mycars';
  import { mapState } from 'vuex';
  import {Icon,Button,Row,Col,Image,Tag,Overlay,Popup,NavBar,IndexBar,IndexAnchor,Cell,CellGroup} from "vant";
  export default {
    data () {
      return {
        show:false,
        approve:false,
        activeTab: 0,
        popTitle:'选择品牌',
        brands:true,
        cars:false,
        models:false,
        list: [],
        brandlist:[],
        carslist:[],
        modelist:[],
        brand_id:'',
        car_id:'',
        car_model_id:'',
        brand_img:'',
        brand_name:'',
        model_name:'',
        goTitle:'',
        indexList: ['A','B', 'C','D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M','N','O', 'P','Q','R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      }
    },
    computed: {
      ...mapState({
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      if(!Lockr.get('token')) {

        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              this.$appService.needLogin()
            }
          })
        }

        this.$toast('请先登录')
        return false
      }
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }

      if(this.$route.params.show){
        this.show=this.$route.params.show
        this.getBrands()
      }
      this.getMycars()
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getMycars(){
        list.getMycars().then(res => {
          if(res.data.state == 1) {
            let list=res.data.data
            for(var i=0;i<list.length;i++){
              var number_plate= list[i].number_plate
              list[i].p_plate = number_plate.substring(0, 1)
              list[i].p_num = number_plate.substring(1, 7)
            }
            this.list=list
          }
        })
      },
      getBrands(){
        list.getBrands().then(res => {
          if(res.data.state == 1) {
            this.brandlist=res.data.data
          }
        })
      },
      showRight(){
        this.show=true
        this.getBrands()
      },
      onClickLeft(){
       let brands=this.brands
       let cars=this.cars
       let models=this.models
       if(brands){
        this.show=false
        this.brands=true
        this.cars=false
      }else if(cars){
        this.brands=true
        this.cars=false
        this.popTitle='选择品牌'
      }else if(models){
        this.cars=true
        this.models=false
        this.popTitle='选择车系'
      }
    },
    changeCar(e){
      let code=e.currentTarget.dataset.code
      let brand_img=e.currentTarget.dataset.img
      let brand_name=e.currentTarget.dataset.name
      this.brands=false
      this.cars=true
      this.popTitle='选择车系'
      this.brand_id=code
      this.brand_img=brand_img
      this.brand_name=brand_name
      list.getCars(code).then(res => {
        if(res.data.state == 1) {
          this.carslist=res.data.data
        }
      })
    },
    changeModel(e){
      let code=e.currentTarget.dataset.code
      let model_name=e.currentTarget.dataset.name
      this.cars=false
      this.models=true
      this.popTitle='选择车型'
      this.car_id=code
      this.model_name=model_name
      list.getModels(code).then(res => {
        if(res.data.state == 1) {
         this.modelist=res.data.data
       }
     })
    },
    changeOk(e){
      let code=e.currentTarget.dataset.code
      this.show=false
      this.brands=true
      this.cars=false
      this.models=false
      this.popTitle='选择品牌'
      this.car_model_id=code
      this.$router.push({
        name: `MyCarInfo`,
        params: {
          brand_id: this.brand_id, 
          car_id: this.car_id,
          car_model_id: this.car_model_id,
          name: e.currentTarget.dataset.name
        }
      })
    },
    close(){
      this.show=false
      this.brands=true
      this.cars=false
      this.models=false
      this.popTitle='选择品牌'
    },
    showBottom(e){
      this.carid=e.currentTarget.dataset.code
      this.audit=e.currentTarget.dataset.audit
      if(e.currentTarget.dataset.audit==0){
        this.goTitle='继续认证'
      }else{
        this.goTitle='查看详情'
      }
      this.approve=true
    },
    approveCar(){
      let carid=this.carid
      this.$router.push({
        name: `MyCarInfo`,
        params: {
          carid:this.carid,
          audit:this.audit
        }
      })
    },
    delCar(){
      var carid=parseInt(this.carid)
      this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
        list.delCar(carid).then(res => {
          if(res.data.state == 1) {
            this.approve=false
            this.$toast.success('删除成功');
            this.getMycars()
          }
        })
      }).catch(() => {
      });
    }
  },
  components: {
    [Icon .name]: Icon ,
    [Button.name]: Button,
    [Row .name]: Row,
    [Col.name]: Col,
    [Image.name]:Image,
    [Tag.name]:Tag,
    [Popup.name]:Popup,
    [IndexBar.name]:IndexBar,
    [IndexAnchor.name]:IndexAnchor,
    [NavBar.name]:NavBar,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup
  }
};
</script>
<style lang="scss">
.mycar{
  padding: 15px;
  .car-box{   
    .car{
     height: 190px;
     margin-top: 20px;
     box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); 
     .van-row{
      margin-top: 20px;
      .carstype{
        margin: auto 0;
      }
      .platenum{
        margin: -10px 0;
      }
      .province{
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        border-bottom: 1px solid #1989fa;
        border-top: 1px solid #1989fa;
      }
      .van-tag::after{
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
      }
    } 
    .van-image{
      margin-top: 10px;
    }
  }
  .nocar{
   height: 120px;
   margin-top: 20px;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); 
   button{
    margin-top: 10%;
    border-radius: 15px;
    width: 175px;
    height: 35px;
    line-height: 0;
    color: #fff;
    background-color: #F6AB00;
    border:1px solid #F6AB00;
  }
  .van-index-anchor{
    text-align: left;
    width: 100%;
    background: #f8f8f8;
    height: 25px;
    line-height: 1.8;
  }
  .van-index-bar{
    overflow-x: hidden;
    overflow-y: auto;
    height: 90%;
  }
  .van-popup{
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .van-cell{
    padding: 20px 15px;
  }
  .van-icon__image{
    width: 40px;
    height: 40px
  }
  .cars{
    .van-icon__image{
      width: 60px;
      height: 40px
    }
  }
  .mt-5{
    margin-top: 5px;
  }
  .bg{
    background: #eaeaea;
    padding: 5px 15px;
    .van-icon__image{
      height: 24px;
    }
  }
}
} 
}

</style>